import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { sentryReduxEnhancer } from 'services/sentryService';
import reducers from './reducers';

const store = createStore(reducers, composeWithDevTools(applyMiddleware(thunk), sentryReduxEnhancer));

export default store;
